import { render, staticRenderFns } from "./BoxeWinLog.vue?vue&type=template&id=6d0f771c&scoped=true&"
import script from "./BoxeWinLog.vue?vue&type=script&lang=js&"
export * from "./BoxeWinLog.vue?vue&type=script&lang=js&"
import style0 from "./BoxeWinLog.vue?vue&type=style&index=0&id=6d0f771c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f771c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0f771c')) {
      api.createRecord('6d0f771c', component.options)
    } else {
      api.reload('6d0f771c', component.options)
    }
    module.hot.accept("./BoxeWinLog.vue?vue&type=template&id=6d0f771c&scoped=true&", function () {
      api.rerender('6d0f771c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BoxeWinLog.vue"
export default component.exports